import {Deserializable} from "./deserializable.model";

export class SubjectWorkOrder {

work_order_id?: Number; 
work_order_number?: string;
job_id?: number;
to_brand_id?: number;
subject_id?: number;
job_type_id?: number;
file_id?: number;
created_by?: number;
date_created?: string;
work_order_total?: number;
work_order_gst?: number;
work_order_status_id?: number;
work_order_payment_status_id?: number;
work_order_communication_status_id?: number;
from_brand_id?: number;
due_date?: string;
work_order_subtotal?: number;
work_order_payment_total?: number;
work_order_remaining_total?: number;

job_number?: string;
subject_number?: string;
updated_by?: number;
updated_date?: string;
agent_id?: number;
agent_full_name?: string;
work_order_paymet_total?: number;
// Myob Extras Now In Mysql database as well

myob_id?: string;
sync_with_myob?;
myob_array?: any;


created_date_from?: any;
created_date_to?: string;
updated_date_from?: any;
updated_date_to?: string;
brand_type_id?;
access_level?;
myob_sync_status?;


UID?;
Number?;
Date?;
SupplierInvoiceNumber?; // CustomerPurchaseOrderNumber?;
SupplierUID?;  // CustomerUID?;
SupplierName?; // CustomerName?;
SupplierDisplayID?; //
ShipToAddress?; // added
PromisedDate?;
BalanceDueAmount?;
BalanceDueAmountForeign?;
Status?;

TermsPaymentIsDue?;
TermsDiscountDate?;
TermsBalanceDueDate?;
TermsDiscountForEarlyPayment?;
TermsMonthlyChargeForLatePayment?;
TermsDiscountExpiryDate?;
TermsDiscount?;
TermsDueDate?;
TermsFinanceCharge?;

IsTaxInclusive?;
Subtotal?;
SubtotalForeign?;
Freight?;
FreightForeign?;
FreightTaxCodeUID?;
TotalTax?;
TotalTaxForeign?;
TotalAmount?;
TotalAmountForeign?;
CategoryUID?;
SalespersonUID?;
Comment?;
ShippingMethod?;
JournalMemo?;
ReferralSource?;

BillDeliveryStatus?;
AppliedToDate?;
AppliedToDateForeign?;
LastPaymentDate?;


CanApplySurcharge?;
OrderUID?;
OnlinePaymentMethod?;
ForeignCurrencyUID?;
CurrencyExchangeRate?;
LastModified?;
URI?;
RowVersion?;

}




/*
// New myob Work Order Fields for  myob Purchases/Bills

myob_id?: string;
sync_with_myob?;
myob_array?: any;


UID?;
Number?;
Date?;
SupplierInvoiceNumber?; // CustomerPurchaseOrderNumber?;
SupplierUIDUID?;  // CustomerUID?;
SupplierName?; // CustomerName?;
SupplierDisplayID?; //
ShipToAddress?; // added
PromisedDate?;
BalanceDueAmount?;
BalanceDueAmountForeign?;
Status?;

TermsPaymentIsDue?;
TermsDiscountDate?;
TermsBalanceDueDate?;
TermsDiscountForEarlyPayment?;
TermsMonthlyChargeForLatePayment?;
TermsDiscountExpiryDate?;
TermsDiscount?;
TermsDueDate?;
TermsFinanceCharge?;

IsTaxInclusive?;
Subtotal?;
SubtotalForeign?;
Freight?;
FreightForeign?;
FreightTaxCodeUID?;
TotalTax?;
TotalTaxForeign?;
TotalAmount?;
TotalAmountForeign?;
CategoryUID?;
SalespersonUID?;
Comment?;
ShippingMethod?;
JournalMemo?;
ReferralSource?;

BillDeliveryStatus?;
AppliedToDate?;
AppliedToDateForeign?;
LastPaymentDate?;


CanApplySurcharge?;
OrderUID?;
OnlinePaymentMethod?;
ForeignCurrencyUID?;
CurrencyExchangeRate?;
LastModified?;
URI?;
RowVersion?;



*/